import { CSSProperties, useMemo } from 'react'

import { MessageEmailContentProps } from './types'

const emailContentStyle : CSSProperties = {
  pointerEvents: 'none',
  paddingLeft: '8px'
}

export const MessageEmailContent = ({email}: MessageEmailContentProps) => {
  const innerHtml = useMemo(()=>({ __html: email }), [email])
  return <div
    dangerouslySetInnerHTML={innerHtml}
    style={emailContentStyle}
  ></div>
}
